export const MuiDialog = (mode) => {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: "22px 24px",
          fontSize: "22px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: 24,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "12px 24px",
        },
      },
    },
  };
};